import React, { useContext } from 'react';
import * as firebase from "firebase/app";
import "firebase/auth";
import { UserContext } from '../../App';
import { useHistory, useLocation } from 'react-router-dom';

const Facebook = () => {
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    let history = useHistory();
    let location = useLocation();
    let { from } = location.state || { from: { pathname: "/" } };
    const facebookProvider = new firebase.auth.FacebookAuthProvider();
    const handleFacebookLogIn = () => {
        firebase.auth().signInWithPopup(facebookProvider)
            .then(result => {
                const { email } = result.user;
                const signedInUser = { email };
                setLoggedInUser(signedInUser);
                // console.log(result.user);
                history.replace(from);
            })
            .catch(error => {
                console.log(error.code);
                console.log(error.message);
            });
    }
    return (
        <div>
            <button className="btn btn-info" onClick={handleFacebookLogIn}>Continue with Facebook</button>
        </div>
    );
};

export default Facebook;